import { useFlags } from "features/api/flags"

export function useNonStockModalPriceCostFlag(): {
  isNonStockModalPriceCostEnabled: boolean
  isLoading: boolean
} {
  const { ENABLE_NON_STOCK_MODAL_PRICE_COST, isLoading } = useFlags()
  return {
    isNonStockModalPriceCostEnabled: ENABLE_NON_STOCK_MODAL_PRICE_COST.boolVal,
    isLoading,
  }
}
